import { apiConfig } from "../config";
import { $ } from "../third-party-imports";
import { getBrandList, start_loader, stop_loader } from "../util";
import { apiCommonCall } from "./api-call";
import { customLoaderStart } from "./custom-loader-start";
import { customLoaderStop } from "./custom-loader-stop";
import { genrateBroadlyHeader } from "./generate-broadly-header";
import { generateReviewFooter, reviewPagination } from "./generate-review-footer";
import { generateReviewRow } from "./generate-review-row";
import { generateStarRating } from "./generate-star-rating";
import { generateReviewList } from "./genrate-review-list";
import { defaultReviewImg } from "./load-default-review-image";

let webUrl = window.location.href;
let starRating = 5;
var conceptId = $('.concept-rating-display .five-star-badge-display').attr('data-cid');
if(conceptId){
    $('.concept-rating-display .rating-circle').append('<div class="custom-loader"></div>');
    getBrandList(function(data:any){
        if(data.length > 0){
            let afterCom = window.location.href.split('.com')[1];
            let countryId =  afterCom.split('/')[1].replace(/[^a-zA-Z ]/g, "") === "ca" ? 2 : 1;
            let filterData = data.find((el:any)=>el.id == conceptId);
            let minimumRating = filterData?.minimumReviewRating ? filterData?.minimumReviewRating : '';

            localStorage.setItem('brand_c_id',conceptId);
            localStorage.setItem('minimum_rating',minimumRating);
            let apiUrl = `${apiConfig.reviewaggregates}&ConceptId=${conceptId}&CountryId=${countryId}&MinimumRating=${minimumRating}&PageNumber=1&PageSize=10`;
            if($('header')[0])  {
                customLoaderStart();
            }
            apiCommonCall(apiUrl,function(result:any){
                if($('header')[0])  {
                customLoaderStop();
                }
                if(result.length>0){
                    let starObj:any ={}
                    let rating = result[0].overallRating;
                    if(rating.toString().indexOf('.') === -1){
                        rating = rating + '.0'
                    }
                    let grandTotal = result[0].grandTotal?.toLocaleString();
                    starObj = {'overallRating':rating};
                    $('.concept-rating-display .five-star-display').show();
                    if(window.matchMedia("(max-width: 991px)").matches) {
                        $('.nei_brand_header_v1 .concept-rating-display .five-star-badge-display').css('display','block');
                    }
                    $('.concept-rating-display .rating-number').text(rating);
                    $('.concept-rating-display .review-count').text(grandTotal+ ' Reviews');
                    $('.concept-rating-display .five-star-display').append(generateStarRating(starObj,'overrallrating'));
                    customLoaderStop();
                }
            },function (data:any, status:any){
                if($('header')[0]) {
                stop_loader();
                }
                if(status == "error"){ 
                    $('.concept-rating-display .five-star-badge-display').hide();
                }
            })
        }    
    });    
}
if (window.location.href.indexOf("cid") > -1 || window.location.href.indexOf("conceptId") > -1) {
    let urlPath = new URL(webUrl);
    let param = new URLSearchParams(urlPath.search);
    let cid = param.get('cid') ? param.get('cid') : param.get('conceptId');
    let franchiseWebLocationId = param.get('franchiseWebLocationId');
    let generateReviewArray:any = [];
    if(cid){
        getBrandList(function(data:any){
            if(data.length > 0){
                localStorage.removeItem('brand_c_id');
                localStorage.removeItem('minimum_rating');
                localStorage.removeItem('franchiseWeblocation_id')
                let pageNumber = 1;
                let pageSize = 10;
                let concept_id = cid;
                let filterData = data.find((el:any)=>el.id == concept_id);
                let minimumRating = filterData?.minimumReviewRating ? filterData?.minimumReviewRating : '';

                let afterCom = window.location.href.split('.com')[1];
                let countryId =  afterCom.split('/')[1].replace(/[^a-zA-Z ]/g, "") === "ca" ? 2 : 1;
                localStorage.setItem('brand_c_id',concept_id);
                localStorage.setItem('minimum_rating',minimumRating);
                let url = `${apiConfig.reviewaggregates}&ConceptId=${concept_id}&CountryId=${countryId}&MinimumRating=${minimumRating}&PageNumber=${pageNumber}&PageSize=${pageSize}`;
                let totalReviewUrl = `${apiConfig.reviewaggregates}&ConceptId=${concept_id}&CountryId=${countryId}&StarRating=${starRating}&PageNumber=${pageNumber}&PageSize=${pageSize}`;
                if(franchiseWebLocationId){
                   localStorage.setItem('franchiseWeblocation_id',franchiseWebLocationId);
                   url = `${apiConfig.reviewaggregates}&ConceptId=${concept_id}&franchiseWebLocationId=${franchiseWebLocationId}&CountryId=${countryId}&MinimumRating=${minimumRating}&PageNumber=${pageNumber}&PageSize=${pageSize}`;
                   totalReviewUrl = `${apiConfig.reviewaggregates}&ConceptId=${concept_id}&franchiseWebLocationId=${franchiseWebLocationId}&CountryId=${countryId}&StarRating=${starRating}&PageNumber=${pageNumber}&PageSize=${pageSize}`;
                }
                if($('.customer-review-list')[0] && !$('header')[0] || $("#banner-header").text() === 'Customer Reviews') {
                    $('.concept-rating-display .schedule .schedule-now-cta').css('display','none');
                    $('.concept-rating-display .five-star-badge-display').css('display','none');
                }
                start_loader()
                apiCommonCall(totalReviewUrl,function(result:any){
                    stop_loader()                   
                    let header = genrateBroadlyHeader(result,filterData);
                    $('.bannerHeroContainer.tertiary-hero-banner').parent().append(header);
                    $('.concept-rating-display').parent().append(generateReviewRow());
                    getTotalReviews(url)
                    result.forEach(function(item:any){
                        generateReviewArray.push(generateReviewList(item));
                    })
                    $('.customer-review-list .reviews').append(generateReviewArray);
                    $('.customer-review-list').append(generateReviewFooter(result[0]?.grandTotal));
                    reviewPagination(result[0]?.grandTotal);
                    defaultReviewImg();
                    // if($('.customer-review-list')[0] && !$('header')[0]) {
                    //     $('.concept-rating-display .schedule .schedule-now-cta').css('display','none');
                    // }
                    if($('.customer-review-list')[0] && !$('header')[0] || $("#banner-header").text() === 'Customer Reviews') {
                        $('.concept-rating-display .schedule .schedule-now-cta').css('display','none');
                        $('.concept-rating-display .five-star-badge-display').css('display','block');
                    }
                },function (data:any, status:any){
                    stop_loader();
                    if($('.customer-review-list')[0] && !$('header')[0]) {
                        $('.concept-rating-display .schedule .schedule-now-cta').css('display','none');
                    }
                    if(status == "error"){
                    }
                });
                
            }
        })
    } 
}
function getTotalReviews(url: string){
    apiCommonCall(url,function(result:any){
        stop_loader()
        $('#ratingsInfo p.rating-number').text(result[0]?.grandTotal+' Ratings')
    },function (data:any, status:any){
        stop_loader();
        if($('.customer-review-list')[0] && !$('header')[0]) {
            $('#ratingsInfo').css('display','none');
        }
    });
}

$(document).on('click','.review-scheduler-btn',function(){
    $('#located-page').addClass('active');
});
$(document).on('click','.find-cta',function(){
    $('#located-page').addClass('active');
});